<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];

	onMount(() => {
		// Hack to get the script to run after mount
		const tracking_id = configs[0].values.tracking_id || '';
		const marketoMunchkin = document.getElementById('marketoMunchkin');
		// Code from https://developers.marketo.com/javascript-api/lead-tracking/#embedding_the_code
		// Not tested, Marketo do not seem to allow demo accounts
		if (marketoMunchkin) {
			marketoMunchkin.innerText = `(function() {var didInit = false;function initMunchkin() {if(didInit === false) {didInit = true;Munchkin.init('${tracking_id}');}}var s = document.createElement('script');s.type = 'text/javascript';s.async = true;s.src = '//munchkin.marketo.net/munchkin.js';s.onreadystatechange = function() {if (this.readyState == 'complete' || this.readyState == 'loaded') {initMunchkin();}};s.onload = initMunchkin;document.getElementsByTagName('head')[0].appendChild(s);})();`;
		}
	});
</script>

<svelte:head>
	<script id="marketoMunchkin"></script>
</svelte:head>
